export enum EmitterTypes {
  loader,
  parent,
  child
}
